import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\AccountingCode\DeleteAccountingCodeController::deleteMethod
* @see app/Http/Controllers/AccountingCode/DeleteAccountingCodeController.php
* @route '/api/accounting-code/{accounting_code}'
*/
export const deleteMethod = (args: { accounting_code: string | number | { id: string | number } } | [accounting_code: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/api/accounting-code/{accounting_code}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\AccountingCode\DeleteAccountingCodeController::deleteMethod
* @see app/Http/Controllers/AccountingCode/DeleteAccountingCodeController.php
* @route '/api/accounting-code/{accounting_code}'
*/
deleteMethod.url = (args: { accounting_code: string | number | { id: string | number } } | [accounting_code: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { accounting_code: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { accounting_code: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            accounting_code: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        accounting_code: typeof args.accounting_code === 'object'
        ? args.accounting_code.id
        : args.accounting_code,
    }

    return deleteMethod.definition.url
            .replace('{accounting_code}', parsedArgs.accounting_code.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AccountingCode\DeleteAccountingCodeController::deleteMethod
* @see app/Http/Controllers/AccountingCode/DeleteAccountingCodeController.php
* @route '/api/accounting-code/{accounting_code}'
*/
deleteMethod.delete = (args: { accounting_code: string | number | { id: string | number } } | [accounting_code: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\AccountingCode\DeleteAccountingCodeController::undo
* @see app/Http/Controllers/AccountingCode/DeleteAccountingCodeController.php
* @route '/api/accounting-code/{accounting_code}/undo-delete'
*/
export const undo = (args: { accounting_code: string | number } | [accounting_code: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

undo.definition = {
    methods: ["get","head"],
    url: '/api/accounting-code/{accounting_code}/undo-delete',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AccountingCode\DeleteAccountingCodeController::undo
* @see app/Http/Controllers/AccountingCode/DeleteAccountingCodeController.php
* @route '/api/accounting-code/{accounting_code}/undo-delete'
*/
undo.url = (args: { accounting_code: string | number } | [accounting_code: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { accounting_code: args }
    }

    if (Array.isArray(args)) {
        args = {
            accounting_code: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        accounting_code: args.accounting_code,
    }

    return undo.definition.url
            .replace('{accounting_code}', parsedArgs.accounting_code.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AccountingCode\DeleteAccountingCodeController::undo
* @see app/Http/Controllers/AccountingCode/DeleteAccountingCodeController.php
* @route '/api/accounting-code/{accounting_code}/undo-delete'
*/
undo.get = (args: { accounting_code: string | number } | [accounting_code: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AccountingCode\DeleteAccountingCodeController::undo
* @see app/Http/Controllers/AccountingCode/DeleteAccountingCodeController.php
* @route '/api/accounting-code/{accounting_code}/undo-delete'
*/
undo.head = (args: { accounting_code: string | number } | [accounting_code: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: undo.url(args, options),
    method: 'head',
})

const DeleteAccountingCodeController = { deleteMethod, undo, delete: deleteMethod }

export default DeleteAccountingCodeController